import { SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';
import { socialPostStatusSchema } from '../social-post-schema';

export const listSocialPostsV1RequestSchema = z.object({
  channelId: z.number().optional(),
  status: socialPostStatusSchema.optional(),
  provider: z.enum(SOCIAL_PROVIDERS).optional(),
  query: z.string().optional(),
  since: z.number().optional(),
  until: z.number().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
});

export type IListSocialPostsV1Request = z.infer<typeof listSocialPostsV1RequestSchema>;
